<template>
  <div>
    <div v-if="!showPopup" @click="showPopup = true" class="flex-c">
      <span v-if="type == 'company'">
        <Company-Icon class="d-flex" viewBox="0 0 20 20" />
      </span>
      <span v-else>
        <Website-Icon class="d-flex" width="16px" height="17px" />
      </span>
      <span class="icon-img-spacing">{{ text }}</span>
    </div>
    <div v-else>
      <Enter-Domain-Popup
        :data="data"
        :text="`Add company details of <span>` + data.fullName + '</span>'"
        v-on:clickedOutside="showPopup = false"
      ></Enter-Domain-Popup>
    </div>
  </div>
</template>

<script>
import companyIcon from '@/assets/icons/svg/company.svg'
import websiteIcon from '@/assets/icons/svg/earth-globe.svg'
import enterDomainFE from '@/components/EnterDomainPopup'

export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'type', 'data'],
  data: function() {
    return {
      showPopup: false
    }
  },
  components: {
    'Company-Icon': companyIcon,
    'Website-Icon': websiteIcon,
    'Enter-Domain-Popup': enterDomainFE
  },
  methods: {
    hidePopup() {
      this.showPopup = false
    }
  }
}
</script>
